import { useEffect, useRef, useState } from 'react';
import { connect, useStore } from 'react-redux';
import useMedia from 'use-media';
import messageConst from '../../../const/messageConst';
import { Label } from '../../atoms/label';
import { Link } from '../../atoms/link';
import { ModalClose } from '../../atoms/modalClose';
import './../../../resources_membership_hotel/css/hotel/membership_crawl_modal.css';
import { useHistory } from 'react-router-dom';
import { SenyuubiTableContainer } from '../../molecules/senyuubiTableContainer';

const CrawlSenyuubiPopupContainer = (props) => {
    const {
        state,
        onClickOpenDescriptionHomeFlWindow,
        onClickCloseSenyuubiPopupWindow
    } = props;

    let popupFlg = state.senyuubiPopup;

    const popupRef = useRef(null);

    const store = useStore();
    const history = useHistory();
    const isMobilePhone = useMedia({ maxWidth: '480px' });

    const shokaKenriNenList = state.shokaKenriNenList;
    const [familyFlg, setFamilyFlg] = useState(false);
    const [openFacilityFlg, setOpenFacilityFlg] = useState(!!state.openFacilityFlg);

    const login = store.getState().login;
    const loginType = login.loginType
    const resvKaiinken = store.getState().resvKaiinken;
    const membershipFacility = store.getState().membershipFacility;
    const selectKeiyakuNo = resvKaiinken.find(value => value.selected)?.keiyakuNo;
    const selectShisetsuCd = resvKaiinken.find(value => value.selected)?.sisetuCd;
    const [targetKeiyakuNo, setTargetKeiyakuNo] = useState("");
    const searchParam = store.getState().membershipSearchParam;

    useEffect(() => {
        if (searchParam?.keiyakuNo) {
            setTargetKeiyakuNo(searchParam.keiyakuNo);
        } else {
            const reserveInfo = store.getState().membershipReserveComf;
            if (reserveInfo?.keiyakuNo) {
                setTargetKeiyakuNo(reserveInfo.keiyakuNo);
            }
        }
    }, [searchParam])
    useEffect(() => {
        if (popupFlg) {
            
            // 施設の空室フラグと、家族会員フラグを設定
            // ※画面によって処理が異なる
            const currentPage = history.location.pathname;
            if (currentPage.indexOf("hotel/crawlSearch") != -1) { // CRAWL検索画面
                // CRAWL会員の場合、家族会員フラグはfalse固定
                setFamilyFlg(false);
                setOpenFacilityFlgInMembershipFacility(selectShisetsuCd);
            }
            else if (currentPage.indexOf("hotel/search") != -1) { // 検索画面
                setFamilyFlgInkaiinInfoList(selectKeiyakuNo);
                setOpenFacilityFlgInMembershipFacility(selectShisetsuCd);
            } else { // その他
                if (targetKeiyakuNo) {
                    // 対象の施設コードを取得
                    let targetShisetsuCd = "";
                    resvKaiinken.forEach((data) => {
                        if (data.keiyakuNo == targetKeiyakuNo) {
                            targetShisetsuCd = data.sisetuCd;
                        }
                    });

                    // 家族会員フラグを設定
                    if (loginType === 'CRAWL') {
                        // CRAWL会員の場合は、false固定
                        setFamilyFlg(false);
                    } else {
                        setFamilyFlgInkaiinInfoList(targetKeiyakuNo);
                    }

                    // 空室フラグを設定
                    setOpenFacilityFlgInMembershipFacility(targetShisetsuCd);
                }
            }
            popupRef.current.scrollTop = 0;
        }
    }, [popupFlg])

    /**
     * 会員リストの家族会員フラグを設定します。
     * @param {string|null} keiyakuNo 
     */
    const setFamilyFlgInkaiinInfoList = (keiyakuNo) => {
        login.memberInfo?.forEach(member => {
            member.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
                if (kaiinInfo.keiyakuNo == keiyakuNo) {
                    setFamilyFlg(kaiinInfo.familyFlg);
                    return;
                }
            })
        });
    }

    /**
     * 施設情報の空室フラグを設定します。
     * @param {string|null} facilityCd 
     */
    const setOpenFacilityFlgInMembershipFacility = (facilityCd) => {
        membershipFacility.membership.forEach(group => {
            const selectedFacility = group.shisetsuList.find(facility => facility.id == facilityCd);
            if (selectedFacility) {
                setOpenFacilityFlg(selectedFacility.openFlg);
                return;
            }
        });
    }

    return (
        <div className={popupFlg ? 'popupIsShow' : 'popup'} id='js-popup'>
            <div ref={popupRef} className='popupInner'>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickCloseSenyuubiPopupWindow()} />
                    <h4 className='popupInnerText' >占有日</h4>
                </div>
                {familyFlg ?
                    <div className='crawlSenyuubi_errorMessage'>
                        <Label label={messageConst.FAMILY_SENYUUBI_ERROR} />
                    </div>
                    :
                    <>
                        {shokaKenriNenList && 0 < shokaKenriNenList.length ?
                            <>
                                {loginType !== 'CRAWL' ?
                                    <div className='spaceBank_buttonArea'>
                                        <Link linkTitle={messageConst.SPACEBANK_BUTTON_TITLE} className="spaceBank_button" href="https://mypage.rttg.jp/login/pt" target="_blank" rel="noopener noreferrer" />
                                    </div>
                                    : null
                                }
                                <SenyuubiTableContainer popupFlg={popupFlg} popupRef={popupRef} shokaKenriNenList={shokaKenriNenList} onClickOpenDescriptionHomeFlWindow={onClickOpenDescriptionHomeFlWindow} />
                                {loginType !== 'CRAWL' ?
                                    <div className='spaceBank_buttonArea'>
                                        <Link linkTitle={messageConst.SPACEBANK_BUTTON_TITLE} className='spaceBank_button' href="https://mypage.rttg.jp/login/pt" target="_blank" rel="noopener noreferrer" />
                                    </div>
                                    : null
                                }
                            </>
                            :
                            <div className='crawlSenyuubi_errorMessage'>
                                <Label label={openFacilityFlg ? (loginType === 'CRAWL' ? messageConst.CRAWL_SENYUUBI_ERROR : messageConst.NOT_EXIST_SENYUUBI_ERROR ) : messageConst.CLOSE_FACILITY_SENYUUBI_ERROR} />
                            </div>
                        }
                    </>
                }
            </div>
            <div className='blackBackground' id='js-black-bg'></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        resvKaiinken: state.resvKaiinken,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CrawlSenyuubiPopupContainer);